var React = require('react');

function Album (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zM224 416a160 160 0 1 1 160-160 160 160 0 0 1-160 160z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M224 96a160 160 0 1 0 160 160A160 160 0 0 0 224 96zm0 192a32 32 0 1 1 32-32 32 32 0 0 1-32 32z","className":"fa-primary","key":2})]);
}

Album.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Album;

Album.default = Album;
